import { render, staticRenderFns } from "./LetterManagement.vue?vue&type=template&id=50e95fde&"
import script from "./LetterManagement.vue?vue&type=script&lang=js&"
export * from "./LetterManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports